import { createEvent, restore, sample } from 'effector'
import { libraryGridPurchasedTvShowsWidget } from '~/widgets/library/grid/purchased/tvShows'

export const setContentLoading = createEvent<boolean>()

export const $contentLoading = restore(setContentLoading, false)

sample({
  clock: libraryGridPurchasedTvShowsWidget.$isGridPurchasedTvShowsLoading,
  target: setContentLoading,
})
